import { useEffect, useState } from "react"
import bscstakeAbi from '../json/bscstake.json';
import { toast } from "react-toastify";
import { DECIMALS, DEFAULT_CHAIN, contract } from "../helper/constant";
import { getMultiCall } from "../helper/contractHelper";
import { getWeb3 } from "../helper/functions";




export const useCommonStats = (updater) => {

    let web3 = getWeb3();

    

    const [stats, setStats] = useState({
        totalDistributed: 0,
        totalStaked: 0,
        totalUnstaked: 0,
        totalStakers: 0,
        stakeAmounts: [],
        stakeApys: [],
        stakeDays : [],
        getTokenPrice: 0,
        RefLevel : []
    });

    let stakeContract = new web3.eth.Contract(bscstakeAbi, contract[DEFAULT_CHAIN].STAKE_ADDRESS);

    useEffect(() => {
        const fetch = async () => {
            try {
                
                const data = await getMultiCall([
                    stakeContract.methods.StakersCount(), //0
                    stakeContract.methods.totalDistributed(), //1
                    stakeContract.methods.totalStaked(), //2
                    stakeContract.methods.totalUnstaked(), //3
                    stakeContract.methods.getTokenPrice(), //4
                    stakeContract.methods.getContractInfo(), //5
                ]);

  
                setStats({
                    totalStakers: data[0],
                    totalDistributed: data[1] / Math.pow(10, DECIMALS),
                    totalStaked: data[2] / Math.pow(10, DECIMALS),
                    totalUnstaked: data[3] / Math.pow(10, DECIMALS),
                    stakeAmounts : data[5][0],
                    stakeApys : data[5][4],
                    stakeDays : data[5][1],
                    RefLevel : data[5][3],
                    getTokenPrice: data[4] / Math.pow(10, 18),
                })
            }
            catch (err) {
                console.log(err.message);
                toast.error(err.reason)
            }
        }


        fetch();

        // eslint-disable-next-line
    }, [updater]);

    return stats;
}
